export const DM_LEGAL_ENTITY_ID = 'LegalEntityId';
export const DM_API_TOKEN = 'ApiToken';
export const DM_LOGIN = 'Login';
export const DM_PASSWORD = 'Password';
